var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('list-vue',{attrs:{"busqueda":_vm.busqueda,"busquedaTraduccion":_vm.busquedaTraduccion,"busquedaMedidas":_vm.busquedaMedidas,"opciones":_vm.opciones,"moduloTitulo":_vm.moduloTitulo,"pantallaTitulo":_vm.pantallaTitulo,"rutaConsulta":_vm.rutaConsulta,"buttonsPage":_vm.buttonsPage,"busquedaCampos":_vm.busquedaCampos}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }